<!--
 * @description 图片/视频上传组件
 * @component uploadPicture
 * @author 
 * @version 1.1.0
 * 
 * @功能说明
 * 1. 支持图片和视频的上传与管理
 * 2. 支持单选/多选模式
 * 3. 支持拖拽上传图片（最多9张）
 * 4. 支持图片预览、删除、搜索
 * 5. 支持分页显示素材列表
 * 6. 支持自定义上传文件名（如：课程名称、课程名称+时间等）
 * 
 * @依赖说明
 * - Element UI 组件: el-tabs, el-tab-pane, el-row, el-button, el-upload, el-input, 
 *   el-pagination, el-dialog, el-loading, el-message, el-icon
 * - API 接口:
 *   - this.$api.rGet('file', params) - 获取文件列表
 *   - this.$api.rPost('file/upload/image', formData) - 上传图片
 * - 全局方法:
 *   - fileDeleteApi(attId) - 删除文件
 *   - fileImageApi(formData, data) - 上传图片（旧接口）
 *   - this.$modalSure() - 确认弹窗
 * 
 * @Props
 * @param {String} pictureType - 图片类型，默认为空
 * @param {Boolean} multiple - 是否支持多选，默认 false
 * @param {String} modelName - 模型名称，用于区分不同模块的上传，默认为空
 * @param {Array} checkedMore - 已选中的图片列表，默认 []
 * @param {String} labelName - 标签名称，默认为空
 * @param {String} customFileName - 自定义上传文件名，支持传入课程名称等，多图上传时自动添加序号后缀，默认为空
 * 
 * @Events
 * @event getImage - 返回选中的图片列表，参数: Array<图片对象>
 * 
 * @使用示例
 * 基础用法:
 * <upload-picture 
 *   :picture-type="'product'"
 *   :multiple="true"
 *   :model-name="'product'"
 *   :checked-more="selectedImages"
 *   @getImage="handleGetImage"
 * />
 * 
 * 自定义文件名用法（课程封面上传）:
 * <upload-picture 
 *   :model-name="'课程'"
 *   :custom-file-name="courseName"
 *   @getImage="handleGetImage"
 * />
 * 
 * 自定义文件名用法（课程名称+时间）:
 * <upload-picture 
 *   :model-name="'课程'"
 *   :custom-file-name="courseName + '_' + currentTime"
 *   @getImage="handleGetImage"
 * />
 -->
<template>
  <div>
    <el-tabs v-model="typeDate" class="list-tabs" @tab-click="radioChange">
      <el-tab-pane label="图片" name="pic"></el-tab-pane>
      <el-tab-pane v-if="modelName !== 'diy' && modelName ==='imagesAndVideos'" label="视频" name="video"></el-tab-pane>
    </el-tabs>
    <el-row :gutter="0" v-loading="loadingPic">
        <div class="conter mb15 relative">
          <div class="toolbar">
            <div class="toolbar-left">
              <el-button type="primary" size="small" @click="handleChangeImage" v-if="typeDate === 'pic'">
                <i class="el-icon-upload2"></i> 上传图片
              </el-button>
              <el-upload
                v-if="typeDate !== 'pic'"
                class="upload-demo"
                action
                :http-request="handleUploadForm"
                :on-change="imgSaveToUrl"
                :show-file-list="false"
                multiple
              >
                <el-button type="primary" size="small"><i class="el-icon-upload2"></i> 上传视频</el-button>
              </el-upload>
              <el-button type="primary" size="small" @click="checkPics" v-if="!pictureType">
                <i class="el-icon-check"></i> 使用选中
              </el-button>
              <el-button size="small" @click.stop="editPicList()">
                <i class="el-icon-delete"></i> 删除选中
              </el-button>
            </div>
            <div class="toolbar-right">
              <el-input
                v-model.trim="tableData.keywords"
                size="small"
                class="searchInput"
                :placeholder="typeDate == 'pic' ? '搜索图片名称' : '搜索视频名称'"
                suffix-icon="el-icon-search"
                style="width: 200px"
                clearable
                @keyup.enter.native="searchFile"
                @change="searchFile"
              />
            </div>
          </div>
          <div class="pictrueList acea-row">
            <div v-show="isShowPic" class="imagesNo">
              <i class="el-icon-picture" style="font-size: 60px; color: rgb(219, 219, 219)" />
              <span class="imagesNo_sp">素材为空</span>
            </div>
            <!-- 宫格布局 -->
            <div
              class="conters"
              ref="myDiv"
            >
              <div
                v-for="(item, index) in pictrueList.list"
                :key="item.id || index"
                class="gridPic"
                :class="{ 'is-selected': item.isSelect }"
                :title="item.alias"
                @click="changImage(item, index, pictrueList.list)"
                @mouseenter="handleMouse(item, true)"
                @mouseleave="handleMouse(item, false)"
              >
                <div class="gridPic-img-wrap">
                  <img
                    :src="item.url"
                    v-if="item.attType !== 'video/mp4'"
                  />
                  <video
                    :src="item.sattDir"
                    v-if="item.attType == 'video/mp4'"
                    muted
                    loop
                    playsinline
                  ></video>
                  <div class="select-overlay" v-if="item.isSelect"></div>
                  <div class="select-mark" v-if="item.isSelect">
                    <i class="el-icon-check"></i>
                  </div>
                  <span class="num_badge" v-if="item.isSelect && item.num > 0">{{ item.num }}</span>
                  <div class="hover-actions" v-if="item.isCk && pictureType">
                    <i class="el-icon-delete" @click.stop="deleteOperate(item)"></i>
                  </div>
                </div>
                <div class="imgTitle" :title="item.alias">
                  {{ item.alias }}
                </div>
              </div>
            </div>
            <div class="block">
              <el-pagination
                :page-size="tableData.pageSize"
                :current-page="tableData.page"
                :pager-count="5"
                layout="prev, pager, next, jumper"
                :total="pictrueList.total"
                @size-change="handleSizeChange"
                @current-change="pageChange"
              />
            </div>
          </div>
        </div>
    </el-row>

    <el-dialog
      custom-class="uploadDialog"
      title="上传图片"
      :visible.sync="visiblePic"
      @close="onCallback(false)"
      class="handleDialog"
      width="1300px"
      :append-to-body="true"
    >
      <div v-show="visiblePic" class="upload-cropper-wrap">
        <div class="direct-upload-section">
          <div class="direct-upload-main">
            <el-upload
              class="upload-dragger"
              drag
              action
              :on-change="handleDirectFileChange"
              :show-file-list="false"
              multiple
              accept="image/png, image/jpeg, image/gif, image/jpg"
              :auto-upload="false"
            >
              <div class="upload-content">
                <i class="el-icon-upload"></i>
                <div class="upload-text">将图片拖到此处，或<em>点击选择</em></div>
                <div class="upload-tip">支持 jpg、png、gif 格式，最多选择9张</div>
              </div>
            </el-upload>
          </div>
          <div class="direct-upload-preview">
            <div class="preview-header">
              <span class="preview-title">待上传图片</span>
              <span class="preview-count" v-if="directUploadFiles.length > 0">{{ directUploadFiles.length }} 张</span>
              <div class="preview-actions" v-if="directUploadFiles.length > 0">
                <el-button type="text" size="mini" @click="clearDirectFiles">清空</el-button>
              </div>
            </div>
            <div class="preview-grid" v-if="directUploadFiles.length > 0">
              <div class="preview-item" v-for="(file, index) in directUploadFiles" :key="index">
                <img :src="file.preview" alt="preview" />
                <div class="preview-item-overlay">
                  <i class="el-icon-delete" @click="removeDirectFile(index)"></i>
                </div>
                <div class="preview-item-info">
                  <span class="file-name">{{ file.name }}</span>
                  <span class="file-size">{{ formatFileSize(file.size) }}</span>
                </div>
              </div>
            </div>
            <div class="preview-empty-state" v-else>
              <i class="el-icon-picture-outline"></i>
              <span>选择图片后将在此处显示预览</span>
            </div>
            <div class="preview-footer">
              <el-button type="primary" size="small" @click="submitDirectUpload" :loading="directUploading" :disabled="directUploadFiles.length === 0">
                {{ directUploading ? '上传中...' : '开始上传' }}
              </el-button>
              <el-button size="small" @click="onCallback(false)">取消上传</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'uploadPicture',
  props: {
    pictureType: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    modelName: {
      type: String,
      default: '',
    },
    checkedMore: {
      type: Array,
      default: () => [],
    },
    labelName: {
      type: String,
      default: '',
    },
    customFileName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      checkDialogData: {},
      uploadName: '上传',
      visiblePic: false,
      loadingPic: false,
      loading: false,
      modals: true,
      tableData: {
        page: 1,
        pageSize: 18,
        type: 'image',
        keywords: ''
      },
      pictrueList: {
        list: [],
        total: 0,
      },
      isShowPic: false,
      checkPicList: [],
      ids: [],
      localImg: '',
      videoStatus: false,
      typeDate: 'pic',
      directUploadFiles: [],
      directUploading: false,
    };
  },
  created() {
    this.pictureType ? (this.tableData.pageSize = 18) : (this.tableData.pageSize = 18);
    if (this.$route && this.$route.query.field === 'dialog') import('../js/internal.js');
    this.getFileListAsync();
  },
  methods: {
    searchFile() {
      this.tableData.page = 1;
      this.getFileListAsync();
    },
    //宫格删除操作
    deleteOperate(item) {
      this.$modalSure().then(() => {
        fileDeleteApi(item.attId).then(() => {
          this.$message.success('刪除成功');
          this.tableData.page = 1;
          this.getFileListAsync();
          this.uploadName = '上传';
        });
      });
    },
    //移入移出显示操作
    handleMouse(item, type) {
      this.$set(item, 'isCk', type);
    },
    //promise 获取列表
    getFileListAsync() {
      return new Promise((resolve, reject) => {
        this.loadingPic = true;
        this.$api.rGet('file', this.tableData)
          .then(async (res) => {
            res.data.data.forEach((el) => {
              this.$set(el, 'isSelect', false);
              this.$set(el, 'isEdit', false);
              this.$set(el, 'isShowEdit', false);
              this.$set(el, 'realName', false);
              this.$set(el, 'num', 0);
              this.$set(el, 'alias', el.name || (el.module ? el.module + '-图片' : '未命名图片'));
              this.$set(el, 'newName', el.alias ? el.alias.replace(/\.[^/.]+$/, '') : '');
              this.$set(el, 'attId', el.attId || el.id);
            });
            this.pictrueList.list = res.data.data;
            if (this.tableData.page === 1 && this.pictrueList.list.length > 0)
              this.pictrueList.list[0].localImg = this.localImg;
            if (this.pictrueList.list.length) {
              this.isShowPic = false;
            } else {
              this.isShowPic = true;
            }
            this.pictrueList.total = res.data.total || res.total;
            this.checkPicList = [];
            this.loadingPic = false;
            resolve();
          })
          .catch(() => {
            this.loadingPic = false;
          });
      });
    },
    // 选取图片后自动回调，里面可以获取到文件
    imgSaveToUrl(event) {
      // 也可以用file
      this.localFile = event.raw; // 或者 this.localFile=file.raw

      // 转换操作可以不放到这个函数里面，
      // 因为这个函数会被多次触发，上传时触发，上传成功也触发
      let reader = new FileReader();
      reader.readAsDataURL(this.localFile); // 这里也可以直接写参数event.raw

      // 转换成功后的操作，reader.result即为转换后的DataURL ，
      // 它不需要自己定义，你可以console.integralLog(reader.result)看一下
      reader.onload = () => {
        // console.integralLog(reader.result)
      };

      /* 另外一种本地预览方法 */
      let URL = window.URL || window.webkitURL;
      this.localImg = URL.createObjectURL(event.raw);
    },
    // 上传
    handleUploadForm(param) {
      const formData = new FormData();
      const data = {
        model: 'product',
        pid: this.tableData.pid ? this.tableData.pid : 0,
      };
      formData.append('multipart', param.file);
      this.uploadPic(formData, data);
    },
    uploadPic(formData, data) {
      let loading = this.$loading({
        lock: true,
        text: '上传中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      fileImageApi(formData, data)
        .then((res) => {
          loading.close();
          this.$message.success('上传成功');
          this.tableData.page = 1;
          this.getFileListAsync();
          this.onCallback();
        })
        .catch((res) => {
          this.onCallback();
          loading.close();
        });
    },
    pageChange(page) {
      this.tableData.page = page;
      this.checkPicList = [];
      this.getFileListAsync();
    },
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.getFileListAsync();
    },
    // 选中图片
    changImage(item, index, row) {
      let activeIndex = 0;
      if (!item.isSelect) {
        this.$set(item, 'isSelect', true);
        this.checkPicList.push(item);
      } else {
        this.$set(item, 'isSelect', false);
        this.checkPicList.map((el, idx) => {
          if (el.attId == item.attId) {
            activeIndex = idx;
          }
        });
        this.checkPicList.splice(activeIndex, 1);
      }
      
      this.ids = [];
      this.checkPicList.forEach((pic, i) => {
        this.ids.push(pic.attId);
        this.$set(pic, 'num', i + 1);
      });
      
      this.pictrueList.list.forEach((el) => {
        const selectedPic = this.checkPicList.find(pic => pic.attId === el.attId);
        if (selectedPic) {
          this.$set(el, 'num', selectedPic.num);
        } else {
          this.$set(el, 'num', 0);
        }
      });
      
      if (this.checkPicList.length > 0) {
        this.uploadName = '裁剪图片';
      } else {
        this.uploadName = '上传';
      }
    },
    // 点击使用选中图片
    checkPics() {
      if (!this.checkPicList.length) return this.$message.warning('请先选择图片');
      if (this.$route && this.$route.query.field === 'dialog') {
        let str = '';
        for (let i = 0; i < this.checkPicList.length; i++) {
          str += '<img src="' + this.checkPicList[i].sattDir + '">';
        }
        /* eslint-disable */
        nowEditor.dialog.close(true);
        nowEditor.editor.setContent(str, true);
      } else {
        if (!this.multiple && this.checkPicList.length > 1) {
          return this.$message.warning('最多只能选一张图片');
        }
        this.$emit('getImage', [...this.checkedMore, ...this.checkPicList]);
      }
    },
    // 删除图片
    editPicList(tit) {
      if (!this.checkPicList.length) return this.$message.warning('请先选择图片');
      this.$modalSure().then(() => {
        fileDeleteApi(this.ids.join(',')).then(() => {
          this.$message.success('刪除成功');
          this.tableData.page = 1;
          this.getFileListAsync();
          this.checkPicList = [];
          this.uploadName = '上传';
        });
      });
    },
    videoChange(val) {
      if (val == false) {
        this.$set(this.tableData, 'type', 'image');
        this.tableData.page = 1;
        this.getFileListAsync();
      } else {
        this.$set(this.tableData, 'type', 'video');
        this.tableData.page = 1;
        this.getFileListAsync();
      }
    },
    radioChange(event) {
      if (event.name === 'video') {
        this.videoChange(true);
      } else {
        this.videoChange(false);
      }
    },
    handleChangeImage() {
      if (this.checkPicList.length > 1) {
        return this.$message.warning('最多只能选一张图片');
      }
      this.visiblePic = true;
    },
    onCallback() {
      this.visiblePic = false;
      this.clearDirectFiles();
    },
    handleDirectFileChange(file) {
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/i.test(file.name)) {
        this.$message.warning('图片类型必须是 gif、jpg、png、bmp 中的一种');
        return;
      }
      if (this.directUploadFiles.length >= 9) {
        this.$message.warning('一次最多只能上传9张图片');
        return;
      }
      const preview = URL.createObjectURL(file.raw);
      this.directUploadFiles.push({
        file: file.raw,
        name: file.name,
        size: file.size,
        preview: preview,
      });
    },
    removeDirectFile(index) {
      URL.revokeObjectURL(this.directUploadFiles[index].preview);
      this.directUploadFiles.splice(index, 1);
    },
    clearDirectFiles() {
      this.directUploadFiles.forEach(item => {
        URL.revokeObjectURL(item.preview);
      });
      this.directUploadFiles = [];
    },
    async submitDirectUpload() {
      if (this.directUploadFiles.length === 0) {
        this.$message.warning('请先选择图片');
        return;
      }
      
      this.directUploading = true;
      const loading = this.$loading({
        lock: true,
        text: '上传中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      
      let successCount = 0;
      let failCount = 0;
      
      for (let i = 0; i < this.directUploadFiles.length; i++) {
        const item = this.directUploadFiles[i];
        try {
          const formData = new FormData();
          formData.append('upload', item.file);
          formData.append('module', this.modelName || 'default');
          
          let finalFileName = this.customFileName;
          if (finalFileName) {
            if (this.directUploadFiles.length > 1) {
              finalFileName = `${this.customFileName}_${i + 1}`;
            }
            const ext = item.name.substring(item.name.lastIndexOf('.'));
            finalFileName += ext;
            formData.append('customFileName', finalFileName);
          }
          
          const res = await this.$api.rPost('file/upload/image', formData);
          if (res.status === 1) {
            successCount++;
          } else {
            failCount++;
          }
        } catch (err) {
          failCount++;
        }
      }
      
      loading.close();
      this.directUploading = false;
      
      if (successCount > 0) {
        this.$message.success(`成功上传 ${successCount} 张图片`);
        this.tableData.page = 1;
        this.getFileListAsync();
        this.clearDirectFiles();
      }
      
      if (failCount > 0) {
        this.$message.warning(`${failCount} 张图片上传失败`);
      }
    },
    formatFileSize(bytes) {
      if (bytes === 0) return '0 B';
      const k = 1024;
      const sizes = ['B', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
  },
};
</script>

<style scoped lang="scss">
.upload-demo {
  display: inline-block !important;
  float: left;
}

.conters {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  overflow: visible;
  position: relative;
  padding: 10px 0;
  gap: 16px;
}

.gridPic {
  width: 140px;
  height: 168px;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  border: 2px solid #e4e7ed;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 10;
    
    .hover-actions {
      opacity: 1;
    }
  }
  
  &.is-selected {
    border-color: #409EFF;
    z-index: 5;
    
    .select-mark {
      display: flex;
    }
    
    .select-overlay {
      display: block;
    }
  }
  
  &.is-selected:hover {
    z-index: 15;
  }

  .gridPic-img-wrap {
    width: 100%;
    height: 120px;
    position: relative;
    overflow: hidden;
    background: #f5f7fa;
    
    img, video {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
  
  .select-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(64, 158, 255, 0.15);
    display: none;
    pointer-events: none;
  }
  
  .select-mark {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 24px;
    height: 24px;
    background: #409EFF;
    border-radius: 50%;
    display: none;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    z-index: 10;
    
    i {
      color: #fff;
      font-size: 14px;
      font-weight: bold;
    }
  }
  
  .num_badge {
    position: absolute;
    top: 8px;
    left: 8px;
    min-width: 22px;
    height: 22px;
    background: #fff;
    border: 2px solid #409EFF;
    border-radius: 50%;
    color: #409EFF;
    font-size: 12px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    z-index: 10;
  }
  
  .hover-actions {
    position: absolute;
    top: 8px;
    right: 8px;
    opacity: 0;
    transition: opacity 0.2s;
    z-index: 10;
    
    i {
      width: 28px;
      height: 28px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      
      &:hover {
        background: #f56c6c;
      }
    }
  }
  
  .imgTitle {
    padding: 4px 6px;
    font-size: 12px;
    color: #303133;
    text-align: center;
    line-height: 16px;
    height: 40px;
    flex-shrink: 0;
    overflow: hidden;
    display: -webkit-box !important;
    -webkit-line-clamp: 2 !important;
    -webkit-box-orient: vertical !important;
    word-break: break-all;
    border-top: 1px solid #f0f0f0;
    background: #fff;
  }
}

.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #f5f7fa;
  border-radius: 8px;
  margin-bottom: 16px;
  
  .toolbar-left {
    display: flex;
    gap: 12px;
    align-items: center;
  }
  
  .toolbar-right {
    display: flex;
    gap: 12px;
    align-items: center;
  }
}

.conter {
  width: 100%;
  height: 100%;

  .pictrueList {
    width: 100%;
    overflow: visible;
  }

  .imagesNo {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin: 65px 0;

    .imagesNo_sp {
      font-size: 13px;
      color: #dbdbdb;
      line-height: 3;
    }
  }
}

.relative {
  position: relative;
}

.block {
  width: 100%;
  padding: 10px 0;
  clear: both;

  .el-pagination {
    float: right;
  }
}

.handleDialog {
  z-index: 999999 !important;
}

.direct-upload-section {
  .direct-upload-main {
    .upload-dragger {
      ::v-deep .el-upload {
        width: 100%;
        
        .el-upload-dragger {
          width: 100%;
          height: 220px;
          border: 2px dashed #d9d9d9;
          border-radius: 8px;
          background: #fafafa;
          transition: all 0.3s;
          display: flex;
          align-items: center;
          justify-content: center;
          
          &:hover {
            border-color: #409EFF;
            background: #f0f7ff;
          }
        }
      }
      
      .upload-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        
        .el-icon-upload {
          font-size: 40px;
          color: #c0c4cc;
          margin-bottom: 8px;
        }
        
        .upload-text {
          font-size: 14px;
          color: #606266;
          margin-bottom: 4px;
          
          em {
            color: #409EFF;
            font-style: normal;
          }
        }
        
        .upload-tip {
          font-size: 12px;
          color: #909399;
        }
      }
    }
  }
  
  .direct-upload-preview {
    margin-top: 16px;
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    background: #fff;
    overflow: hidden;
    
    .preview-header {
      display: flex;
      align-items: center;
      padding: 10px 14px;
      background: #f5f7fa;
      border-bottom: 1px solid #e4e7ed;
      
      .preview-title {
        font-size: 13px;
        font-weight: 500;
        color: #303133;
      }
      
      .preview-count {
        font-size: 12px;
        color: #909399;
        margin-left: 8px;
      }
      
      .preview-actions {
        margin-left: auto;
      }
    }
    
    .preview-grid {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      padding: 14px;
      max-height: 350px;
      overflow-y: auto;
    }
    
    .preview-item {
      width: 140px;
      position: relative;
      border-radius: 6px;
      overflow: hidden;
      border: 1px solid #e4e7ed;
      background: #fff;
      
      img {
        width: 100%;
        height: 120px;
        object-fit: cover;
        display: block;
      }
      
      .preview-item-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 120px;
        background: rgba(0, 0, 0, 0.4);
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.2s;
        
        i {
          font-size: 20px;
          color: #fff;
          cursor: pointer;
          
          &:hover {
            color: #f56c6c;
          }
        }
      }
      
      &:hover .preview-item-overlay {
        opacity: 1;
      }
      
      .preview-item-info {
        padding: 6px 8px;
        
        .file-name {
          display: block;
          font-size: 11px;
          color: #606266;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        
        .file-size {
          display: block;
          font-size: 10px;
          color: #909399;
          margin-top: 2px;
        }
      }
    }
    
    .preview-empty-state {
      padding: 60px 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #c0c4cc;
      
      i {
        font-size: 48px;
        margin-bottom: 12px;
      }
      
      span {
        font-size: 14px;
      }
    }
    
    .preview-footer {
      padding: 12px 14px;
      border-top: 1px solid #e4e7ed;
      display: flex;
      justify-content: center;
      gap: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/uploadPicture.vue